
import React, { useEffect, useState } from 'react';
import { FilePdfOutlined, DownloadOutlined } from "@ant-design/icons";

import { useParams } from 'react-router-dom';
import { getCaseReportByIdApi } from '../../../../api/master.api';
import { exportHtmlToDoc, exportHtmlToPdf } from '../exportUtils';
import { generateDistrictSingleHtml } from '../singlePrintTemplates';
const apiOrigin = (process.env.REACT_APP_API_URL || 'https://scms.infotechitsolutionsbd.com/').replace(/\/$/, '');
const resolveDocHref = (fileUrl) => {
    if (!fileUrl) return '#';
    const s = String(fileUrl);
    if (s.startsWith('http://') || s.startsWith('https://')) return s;
    return `${apiOrigin}${s.startsWith('/') ? s : `/${s}`}`;
};

const SingleCaseView = () => {
    // Default caseData structure - you can pass actual caseData as props
    const [caseData, setCaseData] = useState({});
    const { entry_id } = useParams();
 console.log("entry_id", entry_id)
 console.log("caseData", caseData)
    useEffect(() => {
        const getCaseData = async () => {
            try {
                const { data: body } = await getCaseReportByIdApi(Number(entry_id));
                setCaseData(body.data || {});
            } catch (err) {
                console.error(err);
            }
        };
        if (entry_id) getCaseData();
    }, [entry_id]);


    console.log(caseData);


    console.log(entry_id);




    const buildHtml = () => generateDistrictSingleHtml(caseData, d => d);
    const handlePdfDownload = () => { exportHtmlToPdf(buildHtml(), `single-case-${entry_id}.pdf`); };
    const handleDocDownload = () => { exportHtmlToDoc(buildHtml(), `single-case-${entry_id}.doc`); };

    return (
        <div className='page-wrapper'>
            <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', padding: '1rem' }}>
                <div className="container-fluid" style={{ maxWidth: '1400px' }}>
                    {/* Header */}
                    <div className="card mb-0" style={{ borderRadius: '0.5rem 0.5rem 0 0' }}>
                        <div className="card-header border-bottom" style={{ backgroundColor: 'white' }}>
                            <div className="row align-items-center">
                                <div className="col-lg-8 col-md-7 col-12">
                                    <h5 className="mb-2 mb-md-0 fw-medium text-dark">
                                        মামলার বিস্তারিত তথ্য
                                    </h5>
                                </div>
                                <div className="col-lg-4 col-md-5 col-12 text-md-end d-flex justify-content-end gap-2">
                                    <button onClick={handlePdfDownload} className="btn btn-danger btn-sm d-flex align-items-center gap-2">
                                        <DownloadOutlined size={14} /> PDF
                                    </button>
                                    <button onClick={handleDocDownload} className="btn btn-primary btn-sm d-flex align-items-center gap-2">
                                        <DownloadOutlined size={14} /> DOC
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card" style={{ borderRadius: '0 0 0.5rem 0.5rem', borderTop: 'none' }}>
                        <div className="card-body p-0">
                            <div id="printable-single-case" className="row g-0 justify-content-center">
                                {/* Single column content */}
                                <div className="col-12 col-xl-10">
                                    <div className="p-3 p-md-4">
                                        <div className="bg-light rounded p-3 p-md-4">
                                            <h6 className="fw-medium text-dark mb-3 pb-2 border-bottom">
                                                সাধারণ তথ্য
                                            </h6>

                                            <div className="row g-3">
                                                <div className="col-12">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-4 col-12">
                                                            <label className="form-label mb-1 mb-sm-0 fw-medium fw-sm-normal small">
                                                                মামলার জেলা

                                                            </label>
                                                        </div>
                                                        <div className="col-sm-8 col-12">
                                                            <div className="form-control bg-white small">
                                                                {caseData?.result1?.district_name}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-4 col-12">
                                                            <label className="form-label mb-1 mb-sm-0 fw-medium fw-sm-normal small">
                                                                আদালতের নাম

                                                            </label>
                                                        </div>
                                                        <div className="col-sm-8 col-12">
                                                            <div className="form-control bg-white small">
                                                                {caseData?.result1?.court_type_name}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-4 col-12">
                                                            <label className="form-label mb-1 mb-sm-0 fw-medium fw-sm-normal small">
                                                                মামলার ক্যাটেগরি

                                                            </label>
                                                        </div>
                                                        <div className="col-sm-8 col-12">
                                                            <div className="form-control bg-white small">
                                                                {caseData?.result1?.category_name}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-4 col-12">
                                                            <label className="form-label mb-1 mb-sm-0 fw-medium fw-sm-normal small">
                                                                মামলার শ্রেণী/কেস-টাইপ
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-8 col-12">
                                                            <div className="form-control bg-white small">
                                                                {caseData?.result1?.case_type_name}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-4 col-12">
                                                            <label className="form-label mb-1 mb-sm-0 fw-medium fw-sm-normal small">
                                                                মামলা নং
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-8 col-12">
                                                            <div className="form-control bg-white small">
                                                                {caseData?.result1?.case_number}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-4 col-12">
                                                            <label className="form-label mb-1 mb-sm-0 fw-medium fw-sm-normal small">
                                                                মামলা দায়েরের তারিখ
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-8 col-12">
                                                            <div className="form-control bg-white small">
                                                                {caseData?.result1?.filing_date}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="row align-items-start">
                                                        <div className="col-sm-4 col-12">
                                                            <label className="form-label mb-1 mb-sm-0 fw-medium fw-sm-normal small">
                                                                বিষয়বস্তু(সংক্ষিপ্ত)
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-8 col-12">
                                                            <div className="form-control bg-white small" style={{ minHeight: '60px' }}>
                                                                {caseData?.result1?.case_description}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-4 col-12">
                                                            <label className="form-label mb-1 mb-sm-0 fw-medium fw-sm-normal small">
                                                                ফলাফল
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-8 col-12">
                                                            <div className="form-control bg-white small">
                                                                {caseData?.result1?.case_status == 1 ? 'মামলা চলমান' : 'নিষ্পত্তিকৃত মামলা'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <div className="col-12">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-4 col-12">
                                                            <label className="form-label mb-1 mb-sm-0 fw-medium fw-sm-normal small">
                                                                মন্তব্য
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-8 col-12">
                                                            <div className="form-control bg-white small">
                                                                -
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>

                                        <div className="mt-4">

                                            <div className="row">
                                                {caseData?.result6 && caseData?.result6.length > 0 ? (
                                                    caseData?.result6?.map((doc, index) => (
                                                        <div className="col-4 col-sm-3 col-md-2 col-lg-2 mb-3" key={index}>
                                                            <h6 className="fw-medium text-dark mb-3">{doc.file_name ? doc.file_name : `ডকুমেন্ট ${index + 1}`}</h6>

                                                            <a
                                                                href={resolveDocHref(doc.file_url)}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <button
                                                                    className="btn btn-info d-flex align-items-center justify-content-center gap-2 w-100"
                                                                    style={{
                                                                        backgroundColor: '#55ce63',
                                                                        borderColor: '#14b8a6',
                                                                        fontSize: '0.875rem',

                                                                    }}
                                                                >
                                                                    <FilePdfOutlined size={14} />

                                                                </button>
                                                            </a>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <p className="text-muted">কোনো ডকুমেন্ট পাওয়া যায়নি</p>
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-12 col-xl-10">
                                    <div className="p-1 py-md-4">
                                        {/* Shipment Details */}
                                        <div className="mb-4">
                                            <h6 className="fw-medium text-dark mb-3 pb-2 border-bottom">
                                                বাদীর বিবরণ
                                            </h6>
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-sm mb-0">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th scope="col" className="fw-medium text-secondary" style={{ fontSize: '0.75rem', width: '15%' }}>
                                                                ক্রম
                                                            </th>
                                                            <th scope="col" className="fw-medium text-secondary" style={{ fontSize: '0.75rem' }}>
                                                                নাম,মোবাইল নং ,ঠিকানা
                                                            </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {caseData?.result2?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td style={{ fontSize: '0.75rem' }}>{++index}</td>
                                                                <td style={{ fontSize: '0.75rem' }}>{item.plaintiff_name}{item.plaintiff_mobile ? `,${item.plaintiff_mobile}` : ''}{item.plaintiff_address ? `,${item.plaintiff_address}` : ''}</td>

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {/* Respondent Details */}
                                        <div className="mb-4">
                                            <h6 className="fw-medium text-dark mb-3 pb-2 border-bottom">
                                                বিবাদীর বিবরণ
                                            </h6>
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-sm mb-0">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th scope="col" className="fw-medium text-secondary" style={{ fontSize: '0.75rem', width: '15%' }}>
                                                                ক্রম
                                                            </th>
                                                            <th scope="col" className="fw-medium text-secondary" style={{ fontSize: '0.75rem' }}>
                                                                নাম,মোবাইল নং ,ঠিকানা
                                                            </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {caseData?.result3?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td style={{ fontSize: '0.75rem' }}>{++index}</td>
                                                                <td style={{ fontSize: '0.75rem' }}>{item.defendant_name}{item.contact_no ? `,${item.contact_no}` : ''}{item.address ? `,${item.address}` : ''}</td>

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="mb-4">
                                            <h6 className="fw-medium text-dark mb-3 pb-2 border-bottom">
                                                সংশ্লিষ্ট আইন কর্মকর্তার বিবরণ
                                            </h6>
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-sm mb-0">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th scope="col" className="fw-medium text-secondary" style={{ fontSize: '0.75rem', width: '15%' }}>
                                                                ক্রম
                                                            </th>
                                                            <th scope="col" className="fw-medium text-secondary" style={{ fontSize: '0.75rem' }}>
                                                                আইন কর্মকর্তা
                                                            </th>
                                                            <th scope="col" className="fw-medium text-secondary" style={{ fontSize: '0.75rem' }}>
                                                                নাম,মোবাইল নং ,ঠিকানা
                                                            </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {caseData?.result4?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td style={{ fontSize: '0.75rem' }}>{++index}</td>
                                                                <td style={{ fontSize: '0.75rem' }}>{item.law_officer_name}</td>
                                                                <td style={{ fontSize: '0.75rem' }}>{item.officer_name}{item.officer_mobile ? `,${item.officer_mobile}` : ''}{item.officer_address ? `,${item.officer_address}` : ''}</td>

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="mb-4">
                                            <h6 className="fw-medium text-dark mb-3 pb-2 border-bottom">
                                                শুনানি তারিখ এবং বিবরণ
                                            </h6>
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-sm mb-0">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th scope="col" className="fw-medium text-secondary" style={{ fontSize: '0.75rem', width: '15%' }}>
                                                                ক্রম
                                                            </th>
                                                            <th scope="col" className="fw-medium text-secondary" style={{ fontSize: '0.75rem' }}>
                                                                সর্বশেষ শুনানির <br /> তারিখ
                                                            </th>
                                                            <th scope="col" className="fw-medium text-secondary" style={{ fontSize: '0.75rem' }}>
                                                                পরবর্তী শুনানির <br />তারিখ
                                                            </th>
                                                            <th scope="col" className="fw-medium text-secondary" style={{ fontSize: '0.75rem' }}>
                                                                মন্তব্য (সংক্ষিপ্ত)
                                                            </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {caseData?.result5?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td style={{ fontSize: '0.75rem' }}>{++index}</td>
                                                                <td style={{ fontSize: '0.75rem' }}>
                                                                    {item.hearing_date}</td>
                                                                <td style={{ fontSize: '0.75rem' }}>
                                                                    {item.next_hearing_date}</td>
                                                                <td style={{ fontSize: '0.75rem' }}>{item.hearing_notes}</td>

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleCaseView;